import { FaThList } from 'react-icons/fa'
import EmailIcon from '@mui/icons-material/Email';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { BsTelegram } from 'react-icons/bs'

const NavbarHover = (props) => {
    const { para1, icon1, title1, para2, para2a, icon2, title2, para3, icon3, title3, para4, icon4, title4, para5, icon5, title5, para6, icon6, title6, para7, para3a, para4a, para5a, para6a, para7a } = props

    let icons = [
        {
            icon: <EmailIcon className='navbar_icon' />,
        },
        {
            icon: <TwitterIcon className='navbar_icon' />,
        },
        {
            icon: <YouTubeIcon className='navbar_icon' />,
        },
        {
            icon: <LinkedInIcon className='navbar_icon' />,
        },
        {
            icon: <BsTelegram className='navbar_icon' />,
        },
    ]

    let nav_card = [
        {
            icon_s: icon1,
            title: title1,
            para2: para2,
            para2a: para2a,
        },
        {
            icon_s: icon2,
            title: title2,
            para2: para3,
            para2a: para3a,
        },
        {
            icon_s: icon3,
            title: title3,
            para2: para4,
            para2a: para4a,
        },
        {
            icon_s: icon4,
            title: title4,
            para2: para5,
            para2a: para5a,
        },
        {
            icon_s: icon5,
            title: title5,
            para2: para6,
            para2a: para6a,
        },
        {
            icon_s: icon6,
            title: title6,
            para2: para7,
            para2a: para7a,
        },
    ]

    return (
        <>
            <div className='navbar_hover_main_div'>
                <div className='navbar_hover_div'>
                    <div className='navbar_hover_inner_div'>
                        <div className='list_icon_div'>
                            <FaThList />
                        </div>
                        <h3>WEB3 SOLUTIONS</h3>
                    </div>
                    <div className="navbar_hover_inner_div2">
                        <p>{para1}</p>
                    </div>
                    <div>
                        {
                            icons?.map((v, i) => {
                                return (
                                    <>
                                        <div className='navbar_icon_inner_div'>
                                            {v?.icon}
                                        </div>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='navbar_hover_div2'>
                    {
                        nav_card?.map((v, i) => {
                            return (
                                <>
                                    <div className='nav_hover_card flip-card'>
                                        <div class="flip-card-inner">
                                            {/* <div className='flip-card-front'> */}

                                            <div className='nav_hover_icon_div'>
                                                {v?.icon_s}
                                            </div>
                                            <div className='nav_hover_text_div' >
                                                <h3>
                                                    {v?.title}
                                                </h3>
                                                <p>
                                                    {v?.para2}
                                                </p>
                                            </div>
                                            {/* </div> */}

                                            <div className='flip-card-back'>
                                                <div className='nav_hover_card_p2'>
                                                    <p>
                                                        {v?.para2a}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </>
                            )
                        })
                    }
                </div>
            </div>

        </>
    )
}
export default NavbarHover